import { render, staticRenderFns } from "./SharedMapIconSaintRoch.vue?vue&type=template&id=aab18186&scoped=true&"
import script from "./SharedMapIconSaintRoch.vue?vue&type=script&lang=js&"
export * from "./SharedMapIconSaintRoch.vue?vue&type=script&lang=js&"
import style0 from "./SharedMapIconSaintRoch.vue?vue&type=style&index=0&id=aab18186&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aab18186",
  null
  
)

export default component.exports